import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.12 10.342V4.93c0-1.202 1.76-1.202 1.76 0v5.412c0 1.203-1.76 1.203-1.76 0Zm-9.753 4.27-3.646-3.645c-.81-.81.435-2.056 1.246-1.246l3.646 3.646c.81.81-.435 2.056-1.246 1.246Zm21.264 0 3.647-3.645c.81-.81-.436-2.056-1.246-1.246l-3.646 3.646c-.81.81.435 2.056 1.245 1.246ZM13.367 33.387l-3.646 3.646c-.81.81.435 2.056 1.246 1.246l3.646-3.646c.81-.81-.435-2.056-1.246-1.246Zm21.264 0 3.647 3.646c.81.81-.436 2.056-1.246 1.246l-3.646-3.646c-.81-.81.435-2.056 1.245-1.246ZM23.132 43.07v-5.412c0-1.203 1.736-1.203 1.736 0v5.412c0 1.202-1.736 1.202-1.736 0ZM4.93 23.148h5.412c1.203 0 1.203 1.761 0 1.761H4.93c-1.202 0-1.202-1.761 0-1.761Zm32.728-.031h5.411c1.203 0 1.203 1.761 0 1.761h-5.411c-1.203 0-1.203-1.761 0-1.761Z",
    fill: "currentColor"
  }));
};

var SvgSpinner = styled(SvgComponent).withConfig({
  displayName: "Spinner__SvgSpinner",
  componentId: "sc-19roqe8-0"
})(["", " ", ""], size, color);
export default SvgSpinner;